import { defineStore } from 'pinia';
export const useDealSizeStore = defineStore('deal-sizes', {
    state: () => ({
        dealSizes: [] as any[],
        dealSize: null as any | null,
    }),
    actions: {
        async fetchDealSizes() {
            return useNuxtApp().$api().v2.dealSizes.list('', {
                retry: 3,
                retryDelay: 1500,
            }).then(response => {
                this.dealSizes = response
                return response;
            });
        },
        async fetchDealSize(id: string) {
            this.dealSize = await useNuxtApp().$api().v2.dealSizes.get(id, { 'Accept': 'application/json' });
        },
    }
})